import { apiServiceProxy } from '../api-proxy';

import type { ApiServiceProxy } from '../api-proxy';

export class PlgAnticipation {
  constructor(private readonly apiServices: ApiServiceProxy) {}

  public getPlgAnticipation = (): Promise<any> => {
    return this.apiServices.get('/anticipation/can-show-plg').then((response) => response.data);
  };

  public plgSaveAccess = async (screen: string): Promise<any> => this.apiServices.post('/anticipation/save-access-plg', { screen });
}

const plgAnticipationService = new PlgAnticipation(apiServiceProxy);
export default plgAnticipationService;
